module.exports = __webpack_public_path__ + "img/ic_back.5b18ed79.svg";